module.exports = __webpack_public_path__ + "static/media/342SunsetAveNW_2018-06-11_160.fdec3f16.jpg";